import { z } from 'zod/v4'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const cloudflareServerSchema = z.object({
    api_url: z.string().nullish(),
    api_token: z.string().nullish(),
    created_at: zDayJs.nullish(),
    description: z.string().nullish(),
    name: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid(),
})

export const cloudflareServersSchema = z.array(cloudflareServerSchema)

export const paginatedCloudflareServersResponseSchema = z.object({
    data: cloudflareServersSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const retrieveCloudflareServerResponseSchema = z.object({
    data: cloudflareServerSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export type CloudflareServer = z.infer<typeof cloudflareServerSchema>
export type CloudflareServers = z.infer<typeof cloudflareServersSchema>
export type PaginatedCloudflareServersResponse = z.infer<
    typeof paginatedCloudflareServersResponseSchema
>
export type RetrieveCloudflareServerResponse = z.infer<
    typeof retrieveCloudflareServerResponseSchema
>
